import { render, staticRenderFns } from "./ConversationBox.vue?vue&type=template&id=06ec8d74&scoped=true&"
import script from "./ConversationBox.vue?vue&type=script&lang=js&"
export * from "./ConversationBox.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBox.vue?vue&type=style&index=0&id=06ec8d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec8d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ec8d74')) {
      api.createRecord('06ec8d74', component.options)
    } else {
      api.reload('06ec8d74', component.options)
    }
    module.hot.accept("./ConversationBox.vue?vue&type=template&id=06ec8d74&scoped=true&", function () {
      api.rerender('06ec8d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/ConversationBox.vue"
export default component.exports